import { css } from "@emotion/css";

export const sessionTimeoutOverlayCSS = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 98;
  border-radius: 1rem;
`;

export const sessionTimeoutOverlayContentCSS = css`
  background-color: #fff;
  padding: 2rem;
  border-radius: 1rem;
  max-width: 330px;
`;
